import { Component, OnInit } from '@angular/core';
import { authenticationService } from 'src/app/Services/Authentication/authentication.service';
import { ViewController } from '@ionic/core';
import { PopoverController } from '@ionic/angular';
import { SharedService } from 'src/app/Services/sheared/sharedService.service';
import { Router } from '@angular/router';
import { CotationService } from 'src/app/Services/Cotation/cotation.service';



@Component({
  selector: 'app-tooltipsmrh',
  templateUrl: './tooltips.component.html',
  styleUrls: ['./tooltips.component.scss'],
})
export class TooltipsmrhComponent  {

}
